import { render, staticRenderFns } from "./EventAddPage.vue?vue&type=template&id=73b3327c"
import script from "./EventAddPage.vue?vue&type=script&lang=js"
export * from "./EventAddPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports